// Splits a list into two roughly-even halves, the first getting the extra item on an odd length.
export function splitInHalf<T>(items: readonly T[]): [T[], T[]] {
  const mid = Math.ceil(items.length / 2);
  return [items.slice(0, mid), items.slice(mid)];
}
